import React from 'react';
import { Tabs, Text, Gleam } from '@zillow/constellation';
import { ISigningAppointmentSearchRequest } from 'types/signingAppointment/ISigningAppointmentSearchRequest';
import useDetermineCounterForGleamTitle from './hooks/useDetermineCounterForGleamTitle';
import type { FCWithChildren } from '../../../../types/FCWithChildren';

export enum SigningAppointmentsTabNames {
  AllSigningAppointments = 'all-signing-appointments-tab',
  DueTodaySigningAppointments = 'due-today-signing-appointments-tab',
  DueTomorrowSigningAppointments = 'due-tomorrow-signing-appointments-tab',
  DueThisWeekSigningAppointments = 'due-this-week-signing-appointments-tab',
  PastDueSigningAppointments = 'past-due-signing-appointments-tab',
}

export const SigningAppointmentsTabsList: React.FC<{
  selectedTab: string;
  setSelectedTab: React.Dispatch<React.SetStateAction<SigningAppointmentsTabNames>>;
  filterParams: ISigningAppointmentSearchRequest;
  revertToFirstPage: () => void;
}> = ({ selectedTab, setSelectedTab, filterParams, revertToFirstPage }) => {
  const { todayCount, tomorrowCount, weekCount, pastDueCount } = useDetermineCounterForGleamTitle(filterParams);

  return (
    <Tabs selected={selectedTab} onSelected={setSelectedTab}>
      <Tabs.List aria-label="File tabs example">
        <Tabs.Tab id={SigningAppointmentsTabNames.AllSigningAppointments} onClick={revertToFirstPage}>
          All
        </Tabs.Tab>
        <Tabs.Tab id={SigningAppointmentsTabNames.DueTodaySigningAppointments} onClick={revertToFirstPage}>
          <Counter count={todayCount} appearance={'new'}>
            Due Today
          </Counter>
        </Tabs.Tab>
        <Tabs.Tab id={SigningAppointmentsTabNames.DueTomorrowSigningAppointments} onClick={revertToFirstPage}>
          <Counter count={tomorrowCount} appearance={'info'}>
            Due Tomorrow
          </Counter>
        </Tabs.Tab>
        <Tabs.Tab id={SigningAppointmentsTabNames.DueThisWeekSigningAppointments} onClick={revertToFirstPage}>
          <Counter count={weekCount} appearance={'default'}>
            Due This Week
          </Counter>
        </Tabs.Tab>
        <Tabs.Tab id={SigningAppointmentsTabNames.PastDueSigningAppointments} onClick={revertToFirstPage}>
          <Counter count={pastDueCount} appearance={'default'}>
            Past Due
          </Counter>
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
};

interface CounterProps {
  children: React.ReactNode;
  count: number;
  appearance: 'default' | 'info' | 'new';
}

export const Counter: FCWithChildren<CounterProps> = ({ children, count, appearance }) => (
  <Text>
    {children} <Gleam appearance={appearance} count={count} maxSuffix />
  </Text>
);
